import PropTypes from "prop-types"
import parse from "html-react-parser"

import classnames from "classnames"
import ErrorIcon from "images/icons/icon-error.svg?raw"

export const StatusRow = ({ status = "stale" }) => {
  if (status && status !== "stale") {
    return (
      <tr>
        <td colSpan="3" className={status}>
          {status}
        </td>
      </tr>
    )
  }
  return null
}

// TODO: Refactor TableRow into BasicTableRow
export const BasicTableRow = ({ name, value, required, diff }) => {
  let displayValue = value
  let previousValue = null
  let missing = false
  let changed = false

  if (required && !value && value !== 0) {
    missing = true
    displayValue = "Missing Value"
  }

  if (diff) {
    changed = true
    previousValue = <div className="previous">{diff.data.from}</div>
    displayValue = <div className="updated">{displayValue}</div>
  }

  return (
    <tr className={classnames({ missing, changed })}>
      <th>
        {missing && <span>{parse(ErrorIcon)}</span>}
        {name}
      </th>
      <td>
        {previousValue}
        {displayValue}
      </td>
      <td className="no-feedback" />
    </tr>
  )
}
